import { SettingGroup } from "../types"
import { SettingStore } from "~models/setting-store"
import { BlackListStore } from "~models/black-list-store"
import { WalletStore } from "~models/wallet-store"

type PrivacySchemaDeps = {
  settingStore: SettingStore
  blackListStore: BlackListStore
  walletStore: WalletStore
}
export const privacySchema = ({
  settingStore,
  blackListStore,
  walletStore
}: PrivacySchemaDeps): SettingGroup[] => [
    // {
    //     title: "添加方式",
    //     contents: [
    //         {
    //             id: "privacy.addMethod",
    //             type: "navigate",
    //             title: "添加方式设置",
    //             content: "设置他人如何添加您为好友",
    //             suffix: {
    //                 type: "text",
    //                 value: "手机号、二维码",
    //             },
    //             icon: "Frame",
    //             iconColor: "#ff6565",
    //             iconSize: 16,
    //             bg: "rgba(255, 101, 101, 0.1)"
    //         },
    //     ]
    // },
    {
        title: "验证设置",
        contents: [
            {
                id: "privacy.verifyFriend",
                type: "switch",
                title: "好友验证",
                content: "添加好友时需要验证",
                suffix: {
                    type: "switch",
                    value: walletStore.friend_verify,
                    onChange: settingStore.setFriendVerify,
                },
                icon: "hyyz",
                iconColor: "#ec8027",
                iconSize: 16,
                bg: "rgba(236, 128, 39, 0.1)"
            }
        ]
    },
    {
        title: "状态设置",
        contents: [
            {
                id: "privacy.timeOnline",
                type: "navigate",
                title: "上线时间",
                content: "设置在线状态显示规则",
                suffix: {
                    type: "text",
                    value: walletStore.show_online_status === true ? "显示" : "隐藏",
                },
                icon: "sssj",
                iconColor: "#4e98f3",
                iconSize: 16,
                bg: "rgba(78, 152, 243, 0.1)"
            }
        ]
    },
    {
        title: "黑名单管理",
        contents: [
            {
                id: "privacy.blacklist",
                type: "navigate",
                title: "黑名单",
                content: "管理被屏蔽的用户",
                suffix: {
                    type: "text",
                    value: blackListStore.black_list.size.toString(),
                },
                icon: "hmd",
                iconColor: "#c922c4",
                iconSize: 15,
                bg: "rgba(201, 34, 196, 0.1)"
            },
        ]
    },
]
